import React, { useEffect, useState } from "react"
import { Col, Container, Row } from "reactstrap"
import EventsCard from "components/Common/EventsCard"
import { useSelector } from "react-redux"

const UpcomingEventList = () => {
  const [events, setEvents] = useState([])
  const token = useSelector(state => state.auth.token)
  useEffect(() => {
    async function fetchPastEvents() {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/dashboard/get-events-list`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ filter: "active-upcoming" }), // Add if your API expects a body
          }
        )
        const data = await response.json()
        setEvents(data.events || [])
      } catch (err) {
        setEvents([])
      }
    }
    fetchPastEvents()
  }, [])
  console.log("Upcoming Events", events)

  return (
    <div className="wrapper-padd bg-lgpink">
      <Container className="ms-3">
        <Row>
          <h1 className="mainTitle">Upcoming Events</h1>
        </Row>
        <Row className="g-4">
          {events.length === 0 && (
            <Col>
              <p>No Upcoming events found.</p>
            </Col>
          )}
          {events.map(event => (
            <Col sm={12} md={6} lg={4} xl={4} key={event.id}>
              <EventsCard
                to={token ? `/event/${event.url}` : `/event-details/${event.url}`}
                url={`${process.env.REACT_APP_API_URL.replace(
                  "/api",
                  ""
                )}/storage/${event.banner}`}
                mainTitle={event.title}
                subTitle={event.category_name}
                dateTime={
                  event.first_schedule_date && event.first_schedule_start
                    ? `${event.first_schedule_date} ${event.first_schedule_start} Onward`
                    : event.first_schedule_date || ""
                }
                cardClassName="cursor-pointer"
                isUpcoming={true}
                isSoldOut={event.sold_out}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
}

export default UpcomingEventList
